import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const apiModule = api.programs
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function getModel () {
  return {
    id: {
      data: 'id',
      title: 'ID',
      value: null,
      type: null,
      order: 'desc',
      showOrder: true
    },
    createdAt: {
      data: 'createdAt',
      title: 'Дата создания',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    updatedAt: {
      data: 'updatedAt',
      title: 'Дата последнего обновления',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    countMinutes: {
      data: 'countMinutes',
      title: 'Время массажа, мин.',
      value: null,
      type: null,
      order: null,
      showOrder: true
      // handler: function(data) {
      //     return `${data.countMinutes} мин.`
      // }
    },
    info: {
      data: 'info',
      title: 'Информация',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    price: {
      data: 'price',
      title: 'Стоимость, руб.',
      value: null,
      type: null,
      order: null,
      showOrder: true,
      handler: function (data) {
        return `${data.price} руб.`
      }
    },
    dealer: {
      data: 'dealer',
      title: 'Диллер',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    dealerId: {
      data: 'dealerId',
      title: 'ID диллера',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    dealerIdMysql: {
      data: 'dealerIdMysql',
      title: 'ID диллера (MySql)',
      value: null,
      type: null,
      order: null,
      showOrder: true
    }
  }
};

function role () { return localStorage.getItem('role') };

const state = {
  model: getModel(),
  id: null,
  show: 'all',
  question: getModel(),
  questions: [],
  errMain: null,
  errors: {
    countMinutes: null
  }
}
const getters = {
  getModel (state) { return state.model },
  getId (state) { return state.id },
  getShow (state) { return state.show },
  getOne (state) { return state.question },
  getAll (state) { return state.questions },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain }
}
const mutations = {
  setModel (state, data) { state.model = data },
  setId (state, data) { state.id = data },
  setShow (state, data) { state.show = data },
  setOne (state, data) { state.question = data },
  setAll (state, data) { state.questions = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    };
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order == 'desc') order = 'asc'
    else if (order == 'asc') order = null
    state.model[data.param].order = order
  }
}
const actions = {
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    for (let err in errors) {
      commit('setErrors', { param: err, value: null })
    };
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }) {
    commit('setId', null)
    commit('setShow', 'one')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'one')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'all')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (state.id) {
        let result = await httpService.get(apiModule[role()].getOne, { id: state.id })
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      };
      data.params.order = order
      let result = await httpService.get(apiModule[role()].getAll, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async createOrUpdate ({ state, commit, dispatch }, data) {
    try {
      let dataNew = mapper.dataToRequest(data.data)
      if (!dataNew.countMinutes) commit('setErrors', { param: 'countMinutes', value: errorsStr.empty })
      if (parseInt(dataNew.countMinutes) < 1 || parseInt(dataNew.countMinutes) > 31) commit('countMinutes', { param: 'countMinutes', value: errorsStr.empty })
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (!isErr) {
        let result = getModel()
        if (!state.id) result = await httpService.post(apiModule[role()].add, dataNew)
        else result = await httpService.patch(apiModule[role()].update, dataNew)
        commit('setId', result.data.data.id)
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
        dispatch('resetAllErr')
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async delete ({ state, dispatch }) {
    try {
      await httpService.delete(apiModule[role()].delete, { id: state.id })
      dispatch('toAll')
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
